import { createStore } from '@/src/hooks/store/createStore';

interface SrStatusTextState {
  statusText: string;
  setStatusText: (text: string) => void;
}

export const useSrStatusText = createStore<SrStatusTextState>(null, (set) => ({
  statusText: '',
  setStatusText: (statusText) => set({ statusText }),
}));
